import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps'
import { element, number, shape, string } from 'prop-types'
import React from 'react'
import defaultMapOptions from '../defaultMapOptions'
import getVenuesSettings from '../getVenuesSettings'

const venuesSettings = getVenuesSettings()
const key = venuesSettings.googleMapsKey

const VenueMap = withScriptjs(withGoogleMap(props => (
  <GoogleMap
    defaultCenter={{ lat: props.location.lat, lng: props.location.lng }}
    defaultOptions={defaultMapOptions}
    defaultZoom={9}
  >
    <Marker
      icon={{
        scaledSize: new google.maps.Size(19, 27),
        url: '/themes/custom/venues/images/pin.svg',
      }}
      options={{
        optimized: false,
      }}
      position={{ lat: props.location.lat, lng: props.location.lng }}
    />
  </GoogleMap>
)))
VenueMap.defaultProps = {
  containerElement: <div style={{ height: '100%' }} />,
  googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${key}&v=3.exp`,
  loadingElement: <div style={{ height: '100%' }} />,
  mapElement: <div style={{ height: '100%' }} />,
}
VenueMap.propTypes = {
  containerElement: element.isRequired,
  googleMapURL: string.isRequired,
  loadingElement: element.isRequired,
  location: shape({
    lat: number.isRequired,
    lng: number.isRequired,
  }).isRequired,
  mapElement: element.isRequired,
}

export default VenueMap
